<yc-modal *ngIf="formGroup && applicationIds"
  [formGroup]="formGroup"
  [modalHeader]="'CONFIG:hdrUpdateBudget' | ycI18n: 'Update Budget'"
  [modalSubHeader]="applicationIds?.length === 1 ?
    (('common:textApplicationId' | ycI18n: 'Application id') + ' - ' + applicationIds[0]) :
    ('GLOBAL:textApplicationsSelectedDynamic' | ycI18n: '__number__ applications selected': { number: applicationIds?.length })"
  [primaryButtonText]="'GLOBAL:textUpdate' | ycI18n: 'Update'"
  [cancelButtonText]="'common:btnCancel' | ycI18n: 'Cancel'"
  [primaryDisabled]="formGroup.invalid"
  (onPrimaryClick)="onSubmit()"
  (onCancel)="closeModal.emit()">
  <yc-i18n
    [key]="hideFundingSources ? 'CONFIG:textUpdateBudgetHelpNoFs' : 'CONFIG:textUpdateBudgetHelp'"
    [defaultValue]="hideFundingSources ?
      'Select a budget to use for this application. The budget will be the default option for new payments.' :
      'Select a budget and funding source to use for this application. The budget and funding source will be the default option for new payments.'">
  </yc-i18n>
  <br>

  <div class="d-flex flex-column mt-4 mb-4">
    <div>
      <strong>
        <yc-i18n
          key="common:lblProgram"
          defaultValue="Program">
        </yc-i18n>
      </strong>
      {{ programName }}
    </div>
    <div>
      <strong>
        <yc-i18n
          key="common:lblCycle"
          defaultValue="Cycle">
        </yc-i18n>
      </strong>
      {{ cycleName }}
    </div>
    <div *ngIf="currentBudgetId">
      <strong>
        <yc-i18n
          key="common:lblBudget"
          defaultValue="Budget">
        </yc-i18n>
      </strong>
      {{ currentBudgetName }}
    </div>
    <div *ngIf="currentFundingSourceId && !hideFundingSources">
      <strong>
        <yc-i18n
          key="GLOBAL:hdrFundingSource"
          defaultValue="Funding source">
        </yc-i18n>
      </strong>
      {{ currentFundingSourceName }}
    </div>
  </div>
  <yc-typeahead-select
    name="budgetIdFundingSource"
    [items]="budgetFundingSourceOptions"
    [label]="'APPLY:lblBudgetAndFundingSource' | ycI18n: 'Budget and funding source'"
    [showClear]="false"
    [disabled]="!budgetFundingSourceOptions?.length"
    [placeholder]="budgetFundingSourceOptions?.length ?
      (hideFundingSources ?
        ('AWARDS:textSelectABudget' | ycI18n: 'Select a budget') :
        ('AWARDS:textSelectABudgetFundingSource' | ycI18n: 'Select a budget / funding source')
      ) :
      ('BUDGET:alertNoBudgetsAvailableForAssignment' | ycI18n: 'The application does not have any additional open budgets for the current cycle')"
    (onChange)="onSelected($event)">
    <div *ycTypeaheadTemplate="''; let item;"
      class="d-flex justify-content-between align-items-center">
      <span class="white-space-initial">
        {{ item.label }}
      </span>
      <small class="d-block"
        [class.text-danger]="budgetRemainingMap[
          item.value
        ] < 0">
        <yc-i18n key="BUDGET:textNumberRemaining"
          defaultValue="__number__ remaining"
          [context]="{
            number: budgetRemainingMap[item.value] | gcMoney: defaultCurrency: true
          }">
        </yc-i18n>
      </small>
    </div>
  </yc-typeahead-select>
  <div class="mt-2">
    <yc-checkbox *ngIf="showReserveFunds"
      name="reserveFunds"
      [noMargin]="true"
      [optionLabel]="hideFundingSources ?
        ('BUDGET:lblReserveFundsForBudgetNoFs' | ycI18n: 'Reserve funds for budget') :
        ('BUDGET:lblReserveFundsForBudget' | ycI18n: 'Reserve funds for budget and funding source')">
    </yc-checkbox>
  </div>
</yc-modal>